<template>
	<el-container class="order">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-card class="screen-box">
				<el-form ref="form" :model="searchForm" :inline="true" size="small">
					<el-form-item label="订单编号:">
						<el-input placeholder="请输入订单编号" v-model="searchForm.outTradeNo"></el-input>
					</el-form-item>
					<el-form-item label="学生名称:">
						<el-input placeholder="请输入学生名称" v-model="searchForm.studentName"></el-input>
					</el-form-item>
					<el-form-item label="开始时间:">
						<el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"  value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"></el-date-picker>
					</el-form-item>
					<el-form-item label="订单状态:">
						<el-select placeholder="请选择订单状态" v-model="searchForm.isHandle">
							<el-option label="正常" value="false"></el-option>
							<el-option label="异常" value="true"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="交易状态:">
						<el-select placeholder="请选择交易状态" v-model="searchForm.tradeState">
							<el-option label="支付成功" value="SUCCESS"></el-option>
							<el-option label="退款成功" value="REFUND_SUCCESS"></el-option>
							<el-option label="退款中" value="REFUND_PROCESSING"></el-option>
							<el-option label="未支付" value="NOTPAY"></el-option>
							<el-option label="已关闭" value="CLOSED"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
						<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="table-box">
				<el-table :data="tableList" id="table" border>
					<template v-for="(item, index) in tableLabel">
						<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
						</el-table-column>
					</template>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope">
							<el-button type="text"  size="mini" @click="handle(scope.row)" v-if="scope.row.isHandle && scope.row.tradeState != 'REFUND_SUCCESS' && scope.row.tradeState != 'REFUND_PROCESSING'">处理</el-button>
							<el-popconfirm title="您确定要退款吗？" @confirm="refund(scope.row)" v-if="scope.row.tradeState == 'SUCCESS'">
								<el-button type="text" size="mini" slot="reference" style="margin-left:5px;">退款</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</el-card>
		</el-main>
		<!-- 处理弹出层 -->
		<el-dialog title="处理" :visible.sync="dialogSendMsgVisible" class="msgDialog">
			<h1 style="margin-bottom:30px;">订单学生数据</h1>
			<el-form :model="attach" label-width="70px" size="small">
				<el-form-item label="家长手机">
					<el-input :disabled="true" v-model="attach.mobile"></el-input>
				</el-form-item>
				<el-form-item label="所在班级">
					<el-input :disabled="true" v-model="attach.levelName"></el-input>
				</el-form-item>
				<el-form-item label="学生姓名">
					<el-input :disabled="true" v-model="attach.studentName"></el-input>
				</el-form-item>
			</el-form>
			<h1 style="margin: 30px 0;">系统学生数据</h1>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-card class="sel-box">
						<el-input placeholder="输入学生姓名进行搜索" v-model="msgInput" @input="handlerChange" style="width: 100% !important;"></el-input>
						<el-tree :data="msgTreeData" :props="msgTreeDefaultProps" :default-expand-all="true" show-checkbox @check-change="msghHandleCheckChange"></el-tree>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-form :model="selectFormData" label-width="70px" size="small">
						<el-form-item label="家长手机">
							<el-input placeholder="请输入学生姓名进行搜索获取" :disabled="true" v-model="selectFormData.parentMobile"></el-input>
						</el-form-item>
						<el-form-item label="所在班级">
							<el-input placeholder="请输入学生姓名进行搜索获取" :disabled="true" v-model="selectFormData.levelName"></el-input>
						</el-form-item>
						<el-form-item label="学生姓名">
							<el-input placeholder="请输入学生姓名进行搜索获取" :disabled="true" v-model="selectFormData.studentName"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSendMsgVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="handleConfirm()" size="small">发 送</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import { orderPageApi,orderRefundsApi,orderHandleApi,orderLikeNameApi } from "@/axios/api";
	export default {
		name: "Order",
		data() {
			return {
				time:[],
				tableList: [],
				tableLabel: [{
					label: "订单号",
					prop: "outTradeNo"
				},{
					label: "项目名称",
					prop: "name"
				},{
					label: "学生名称",
					prop: "studentName"
				},{
					label: "订单金额(元)",
					prop: "amount",
					formatter: (row) => {
						return (row.amount/100).toFixed(2);
					}
				},{
					label: "支付金额(元)",
					prop: "payerTotal",
					formatter: (row) => {
						return (row.payerTotal/100).toFixed(2);
					}
				},{
					label: "交易状态",
					prop: "tradeState",
					formatter: (row) => {
						if(row.tradeState == 'SUCCESS'){
							return '支付成功'
						}else if(row.tradeState == 'REFUND_SUCCESS'){
							return '退款成功'
						}else if(row.tradeState == 'REFUND_PROCESSING'){
							return '退款中'
						}else if(row.tradeState == 'NOTPAY'){
							return '未支付'
						}else if(row.tradeState == 'CLOSED'){
							return '已关闭'
						}
					}
				},{
					label: "订单状态",
					prop: "isHandle",
					formatter: (row) => {
						return row.isHandle ? '异常' : '正常';
					}
				},{
					label: "创建订单时间",
					prop: "createTime"
				},{
					label: "交易时间",
					prop: "successTime"
				}],
				searchForm: {
					isSearchCount:true,
					page:1,
					limit:10,
					studentName:'',
					isHandle:'',
					outTradeNo:'',
					successTimeStart:'',
					successTimeEnd:'',
					tradeState:''
				},
				totalCount:0,
				pageSizes:[10],

				dialogSendMsgVisible: false,
				msgInput:'',
				msgTreeData:[],
				msgTreeDefaultProps: {
					children: 'children',
					label: 'label'
				},
				selectFormData:{
					levelName:'',
					studentName:'',
					parentMobile:''
				},
				attach:{
					levelName:'',
					studentName:'',
					mobile:''
				},
				id:'',
				cpStudentId:''
			}
		},
		created(){
			this.getData();
		},
		methods:{
			getData(){
				orderPageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm = {
					isSearchCount:true,
					page:1,
					limit:10,
					studentName:'',
					isHandle:'',
					outTradeNo:'',
					successTimeStart:'',
					successTimeEnd:'',
					tradeState:''
				};
				this.getData();
			},
			//处理
			handle(row){
				var attach = JSON.parse(row.attach)
				this.attach = {
					levelName:attach.levelName,
					studentName:attach.studentName,
					mobile:attach.mobile
				}
				this.msgInput = '';
				this.msgTreeData = [];
				this.selectFormData = {
					levelName:'',
					studentName:'',
					parentMobile:''
				},
				this.id = row.id;
				this.dialogSendMsgVisible = true;
			},
			handleConfirm(){
				if(this.id == ''){
					this.$message.warning("请输入学生姓名进行搜索获取");
					return;
				}
				orderHandleApi({cpStudentId:this.cpStudentId,id:this.id}).then((res) => {
					if (res.code == 200){
						this.$message.success("处理成功");
						this.dialogSendMsgVisible = false;
						this.getData();
					}
				}).catch((err) => {});
			},
			//退款
			refund(row){
				orderRefundsApi({id:row.id}).then((res) => {
					if (res.code == 200){
						this.$message.success("退款成功");
						this.getData();
					}
				}).catch((err) => {});
			},
			//输入学生姓名进行搜索
			handlerChange(e){
				if(e.length >= 2){
					orderLikeNameApi({name:e}).then((res) => {
						if (res.code == 200) {
							for(var i =0;i<res.data.length;i++){
								res.data[i].label = res.data[i].studentName + '(' + res.data[i].levelName + ')'
							}
							this.msgTreeData = res.data;
						}
					}).catch((err) => {});
				}else{
					this.msgTreeData = [];
				}
			},
			//树
			msghHandleCheckChange(data, checked, indeterminate){
				this.selectFormData = {
					levelName:data.levelName,
					studentName:data.studentName,
					parentMobile:JSON.parse(data.parentStr)[0].mobile
				}
				this.cpStudentId = data.id;
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			},
			//时间
			timeChange(){
				this.searchForm.successTimeStart = this.time[0];
				this.searchForm.successTimeEnd = this.time[1];
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.el-tree{
		height: auto;
		min-height: auto;
		padding: 20px 0;
	}
	.sel-box{
		margin-bottom: 20px;
	}
	.screen-box{
		margin-left: 12px;
	}
	.table-box{
		margin-left: 12px;
		min-height: 83vh;
	}
	/deep/.el-dialog__header{
		text-align: left;
	}
	h1{
		font-size: 24px;
	}
	/deep/.el-dialog__body{
		padding: 20px;
	}
</style>